
















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class Index extends Vue {
  showImg = true;
  SwiperReport = {
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    slidesPerView: 1,

    observer: true,
    observeParents: true,
    spaceBetween: 90,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    preventClicksPropagation: true,
    speed: 600
  };
  @Prop()
  list!: [];
  @Prop()
  report!: [];
  on_top_enter() {
    (this.$refs.mySwiper as any).$swiper.autoplay.stop();
  }
  on_top_leave() {
    (this.$refs.mySwiper as any).$swiper.autoplay.start();
  }
}
